import { SignupPage } from '@components/Login/Signup';
import { useTranslate } from '@i18n';
import { AuthLayout } from '@layouts';
import { type FC } from 'react';

const Signup: FC = () => {
    const { t } = useTranslate();

    return (
        // Using a hardcoded string as fallback or assuming a key exists
        <AuthLayout title={t('common.signup') || 'Sign up'}>
            <SignupPage />
        </AuthLayout>
    );
};

export default Signup;
